var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { LabelXs, TextM } from '../../../../../infra/dls/components/typography';
import { Checkbox } from '../../../../../infra/dls/components/checkbox/checkbox';
import styles from './styles.module.scss';
export var MultiCheckboxGroup = function (_a) {
    var idPrefix = _a.idPrefix, title = _a.title, options = _a.options, values = _a.values, onChange = _a.onChange;
    return (_jsxs("div", { className: styles['section-wrapper'], children: [_jsx(LabelXs, { color: "secondary", className: "text-uppercase", children: title }), _jsx("div", { className: styles.group, children: options.map(function (opt) { return (_jsx(Checkbox, { id: "".concat(idPrefix, "-").concat(opt.value), checked: values.includes(opt.value), onChange: function (checked) {
                        if (checked) {
                            onChange(__spreadArray(__spreadArray([], values, true), [opt.value], false));
                        }
                        else {
                            onChange(values.filter(function (v) { return v !== opt.value; }));
                        }
                    }, children: _jsx(TextM, { color: "primary", children: opt.label }) }, opt.value)); }) })] }));
};
